import './ContactsDropdownMenu.scoped.sass'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import { useEffect } from 'react'

import { ReactComponent as ExportIcon } from '@/assets/icons/export-icon.svg'
import { ReactComponent as ImportIcon } from '@/assets/icons/import-icon.svg'
import ImportContactsModal from '../../../ImportContactsModal/ImportContactsModal'
import modalService from '@/services/modal.service'

export function ContactsDropdownMenu ({ event }) {
  const iconSize = { width: '18px', height: '18px' }

  const menuOptions = [
    {
      icon: <ImportIcon style={iconSize} />,
      title: 'Import contact',
      action: () => {
        modalService.open(<ImportContactsModal/>)
        dropdownService.close()
      },
      color: 'normal'
    },
    {
      icon: <ExportIcon style={iconSize} />,
      title: 'Export contact',
      action: () => {
        dropdownService.close()
      },
      color: 'normal'
    }
  ]

  useEffect(() => {
    dropdownService.open(menuOptions, 'right', event)
  }, [])

  return <></>
}
